import * as React from "react";

import { $api } from "./client";

/** All segments: reference data, unpaginated. */
export const useSegments = () =>
  $api.useQuery("get", "/api/v1/segments/", undefined, {
    staleTime: 5 * 60 * 1000,
  });

export function useSegmentName(): (id: number | null | undefined) => string {
  const { data } = useSegments();
  return React.useCallback(
    (id) => data?.find((s) => s.id === id)?.name ?? "",
    [data],
  );
}
